export const USER_ENDPOINT_MAPPING = Object.freeze({
  user: 'users/me'
})



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/services/user/user.endpoint.ts